export default __webpack_public_path__ + "static/media/google-pay-grey.0ec3d650.png";